var _style, _ellipse, _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoLinks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_no_links_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40 61",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon_no_links_svg__st1{fill:#f7f7f7}.icon_no_links_svg__st3{fill:#979797}.icon_no_links_svg__st4{fill:none;stroke:#979797;stroke-width:2;stroke-linecap:round}")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 59.7,
    rx: 19,
    ry: 1,
    opacity: 0.6,
    fill: "#979797"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_no_links_svg__a",
    className: "icon_no_links_svg__st1",
    d: "M6 0h23.1L40 10.5V44c0 2.2-1.8 4-4 4H6c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 10.9L28.7 1H6C4.3 1 3 2.3 3 4v40c0 1.7 1.3 3 3 3h30c1.7 0 3-1.3 3-3V10.9z",
    fill: "none",
    stroke: "#979797",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "icon_no_links_svg__st3",
    d: "M0 0h20v10H0z",
    transform: "translate(0 34)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "icon_no_links_svg__st1",
    d: "M7.4 2.3V6c0 .4-.1.8-.3 1.1s-.4.6-.8.7-.7.3-1.2.3c-.7 0-1.3-.2-1.7-.6s-.6-.9-.6-1.5V2.3H4v3.5c0 .4.1.8.3 1s.5.3.9.3c.3 0 .6-.1.8-.3s.3-.5.3-1V2.3h1.1zm2.7 2.5h.4c.4 0 .7-.1.8-.2s.3-.3.3-.6-.1-.5-.3-.6-.5-.2-.9-.2H10v1.6zm0 1V8H8.8V2.3h1.7c.8 0 1.4.1 1.7.4s.6.7.6 1.3c0 .3-.1.6-.3.9s-.4.5-.8.6c.9 1.3 1.4 2.1 1.7 2.5h-1.3l-1.4-2.2h-.6zm4 2.2V2.3h1.2V7h2.3v1h-3.5z",
    transform: "translate(0 34)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "icon_no_links_svg__st3",
    d: "M29 0h.3L40 11.2V11H29z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon_no_links_svg__st4",
    d: "M2.7 10.8c1.7-1 3.4-1.4 4.9-1.4s3.1.5 4.6 1.4M15.6.1c-.8.5-1.6.7-2.3.7-.8 0-1.5-.2-2.2-.7M5 .1c-.8.4-1.6.7-2.4.7S1.2.5.4.1",
    transform: "translate(13 17)"
  }))));
}
export default SvgIconNoLinks;